import { Button, Collapse, List, SimpleGrid, Text, Title } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import {
  IconHome,
  IconMail,
  IconPhone,
  IconPrinter
} from "@tabler/icons-react";
import { Fragment } from "react";
import type { components } from "../../../../../types/api.types";

interface MarktakteurContactInformationProps {
  marktakteur: components["schemas"]["MarktakteurContact"];
}

function MarktakteurContactInformation({
  marktakteur
}: MarktakteurContactInformationProps) {
  const [isOpen, { toggle }] = useDisclosure(false);

  const marktrollenWithContactInformation = marktakteur.marktrollen.filter(
    (data) => !!data.kontaktdaten_marktrolle
  );

  return (
    <div className="MarktakteurContactInformation">
      <SimpleGrid cols={2}>
        <div>
          <Title order={6}>Adresse</Title>
          <Text>
            {marktakteur.firmenname}
            <br />
            {marktakteur.strasse} {marktakteur.hausnummer}{" "}
            {marktakteur.adresszusatz}
            <br />
            {marktakteur.postleitzahl} {marktakteur.ort}
          </Text>
        </div>
        <div>
          <Title order={6}>Zustelladresse</Title>
          <Text>
            {marktakteur.firmenname}
            <br />
            {marktakteur.zustell_strasse || marktakteur.strasse}{" "}
            {marktakteur.zustell_hausnummer || marktakteur.hausnummer}{" "}
            {marktakteur.zustell_adresszusatz || marktakteur.adresszusatz}
            <br />
            {marktakteur.zustell_postleitzahl || marktakteur.postleitzahl}{" "}
            {marktakteur.zustell_ort || marktakteur.ort}
          </Text>
        </div>
        <div>
          <Title order={6}>Kontakt (Marktakteur)</Title>
          <List center>
            {marktakteur.email && (
              <List.Item icon={<IconMail size="16" stroke={1} />}>
                {marktakteur.email}
              </List.Item>
            )}
            {marktakteur.webseite && (
              <List.Item icon={<IconHome size="16" stroke={1} />}>
                {marktakteur.webseite}
              </List.Item>
            )}
            {marktakteur.telefon && (
              <List.Item icon={<IconPhone size="16" stroke={1} />}>
                {marktakteur.telefon}
              </List.Item>
            )}
            {marktakteur.fax && (
              <List.Item icon={<IconPrinter size="16" stroke={1} />}>
                {marktakteur.fax}
              </List.Item>
            )}
          </List>
        </div>
      </SimpleGrid>
      {marktrollenWithContactInformation.length > 0 && (
        <>
          <Button mt="xs" size="xs" variant="default" onClick={toggle}>
            Kontakt Marktrollen {isOpen ? "ausblenden" : "anzeigen"}
          </Button>
          <Collapse expanded={isOpen} pt="sm">
            {marktrollenWithContactInformation.map((data) => {
              return (
                <div key={data.marktrolle}>
                  <Title order={6}>Marktrolle - {data.marktrolle}</Title>
                  <Text mb="xs">
                    {data.kontaktdaten_marktrolle &&
                      data.kontaktdaten_marktrolle
                        .split("\r\n")
                        .map((line, index) => (
                          <Fragment key={index}>
                            {line}
                            <br />
                          </Fragment>
                        ))}
                  </Text>
                </div>
              );
            })}
          </Collapse>
        </>
      )}
    </div>
  );
}

export { MarktakteurContactInformation };
